import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import { MdArrowDropDown } from 'react-icons/md';
import styles from '../input-select.module.css';
import globalStyles from '../../../form.module.css';

const InputSelectDesktop = ({ value, theme, select, toggleSelect }) => {
  const handleToggle = event => {
    toggleSelect(event);
  };

  return (
    <React.Fragment>
      <span className={styles.icon} onClick={() => handleToggle(event)}>
        <MdArrowDropDown />
      </span>
      <input
        name="select"
        placeholder={value}
        type="text"
        readOnly
        style={select ? { cursor: 'none', pointerEvents: 'none' } : {}}
        className={[
          css`
            color: ${theme};
            ::placeholder {
              color: ${theme};
            }
          `,
          styles.input,
          globalStyles.input,
        ].join(' ')}
        onKeyDown={event => event.preventDefault()}
        onClick={() => handleToggle(event)}
      />
    </React.Fragment>
  );
};

InputSelectDesktop.propTypes = {
  value: PropTypes.string,
  theme: PropTypes.string,
  toggleSelect: PropTypes.func,
};

export default InputSelectDesktop;



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-select/input-select-desktop/index.js